export default {
  previousPage: 'Previous',
  nextPage: 'Next',
  goTo: 'Go',
  page: 'Page',
  confirm: 'Confirm'
}
